import { Text } from "@ui-kitten/components";
import React from "react";
import { View } from "react-native";

function SectionTitle({ title, color }: { title: string; color: string }) {
  return (
    <View className="w-fit py-2 px-12 md:px-24 mb-4">
      <Text
        style={{
          fontWeight: "700",
          color,
          letterSpacing: 2,
          fontSize: 24,
          textTransform: "uppercase",
          textDecorationLine: "underline",
        }}
      >
        {title}
      </Text>
    </View>
  );
}

export default SectionTitle;
